import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import flyInLeftGif from '../../../assets/images/transitions/flyInLeft.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_EASE_IN_EDGE_LEFT = 'easeInEdgeLeft';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const easeInEdgeLeftPresetDetails = {
  // The name of the preset.
  name: PRESET_EASE_IN_EDGE_LEFT,

  // A human friendly name for the preset.
  humanName: 'Ease In From Edge Left',

  // A preview of the transition.
  gif: flyInLeftGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'position.x': {
      time: {
        start: 'start.0',
        end: 'start.1000'
      },
      easing: EASINGS.easeOutPower3,
      values: [
        'off.left',
        'position.left'
      ],
      immediateRender: true
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_EASE_IN_EDGE_LEFT,
    options: {},
  },
};

easeInEdgeLeftPresetDetails.template.options = lodash.cloneDeep(easeInEdgeLeftPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_EASE_IN_EDGE_LEFT;

// This defines the value of the presets object.
export default easeInEdgeLeftPresetDetails;
